import React from "react";
const ECGAndPPGStrips = ({ af_detection_summary_data, rtDate, isPdf }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "card", style: { margin: '20px auto' } },
            React.createElement("div", { className: "card-body" },
                React.createElement("div", { className: "card-header bg-transparent", style: { padding: '0.85rem 1.5rem' } },
                    React.createElement("div", { className: "row header-card" }, "ECG and PPG Strips"),
                    React.createElement("div", null,
                        React.createElement("div", { className: "mt-2 text-lg" }, "Signal example"))),
                React.createElement("div", { className: "position-relative" },
                    rtDate && React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "p-3 ml-4" },
                            "Below you can examine the signal taken from your last spot-check taken in (",
                            rtDate,
                            ")"),
                        React.createElement("div", { className: "af-text-scale" }, "Scale: 25mm/s, 10mm/mV")),
                    React.createElement("div", { className: "ecg-report-chart position-relative", key: 'ecg-report-chart' }),
                    React.createElement("div", { style: { marginTop: 30, marginLeft: 100 } }, "* Since the printout is dependent on printer scale the hard copy printout cannot be used to scale with a ruler"))))));
};
export default ECGAndPPGStrips;
